// wi_6b5960f9-952c-48fc-ab25-68e9f9e5b2da: zoom and reload per weapon entity.
// Frame.weapons holds only changes, so they are folded per weapon id once per round and
// looked up by binary search, which keeps stepping backwards exact.
const NONE = { zoomLevel: 0, isReloading: false };

// Decoded protobuf messages read absent fields from prototype defaults, so only own fields count.
const changed = (weapon, key) => Object.prototype.hasOwnProperty.call(weapon, key);

// eslint-disable-next-line import-x/prefer-default-export
export function buildWeaponStates(frames) {
  const changes = new Map();
  (frames ?? []).forEach((frame) => (frame.weapons ?? []).forEach((weapon) => {
    const id = String(weapon.ID);
    const list = changes.get(id) ?? [];
    const last = list[list.length - 1] ?? { ...NONE };
    list.push({
      tick: frame.tick,
      zoomLevel: changed(weapon, 'zoomLevel') ? weapon.zoomLevel : last.zoomLevel,
      isReloading: changed(weapon, 'isReloading') ? weapon.isReloading : last.isReloading,
    });
    changes.set(id, list);
  }));

  function stateAt(weaponId, tick) {
    const list = changes.get(String(weaponId));
    if (!list) return NONE;
    let low = 0;
    let high = list.length - 1;
    let found = -1;
    while (low <= high) {
      const mid = Math.floor((low + high) / 2);
      if (list[mid].tick <= tick) {
        found = mid;
        low = mid + 1;
      } else {
        high = mid - 1;
      }
    }
    return found < 0 ? NONE : list[found];
  }

  return { stateAt };
}
